// src/components/home/FeaturedProperties/FeaturedProperties.jsx
import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FiMapPin, FiHome, FiMaximize2, FiArrowUpRight } from "react-icons/fi";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import httpAction from "../../utils/httpAction";
import converPrice from "../../utils/convertAmount";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import "./FeaturedProperties.css";
import apis from "../../utils/apis";
import useGeneral from "../../hooks/useGeneral";
import { useNavigate } from "react-router-dom";
const DATA = [
  {
    id: 1,
    tag: "Featured",
    price: "PKR 8.9 Cr",
    title: "Modern Villa (5 Bed)",
    location: "DHA Phase 6, Lahore",
    type: "House",
    area: "1 Kanal",
    image:
      "https://images.unsplash.com/photo-1568605114967-8130f3a36994?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: 2,
    tag: "Verified",
    price: "PKR 3.2 Cr",
    title: "Luxury Apartment (3 Bed)",
    location: "Gulberg, Lahore",
    type: "Apartment",
    area: "1,650 sqft",
    image:
      "https://images.unsplash.com/photo-1505691938895-1758d7feb511?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: 3,
    tag: "New",
    price: "PKR 2.1 Cr",
    title: "Corner Plot (10 Marla)",
    location: "Bahria Town, Lahore",
    type: "Plot",
    area: "10 Marla",
    image:
      "https://images.unsplash.com/photo-1523413651479-597eb2da0ad6?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: 4,
    tag: "Featured",
    price: "PKR 5.6 Cr",
    title: "Designer House (4 Bed)",
    location: "Wapda Town, Lahore",
    type: "House",
    area: "12 Marla",
    image:
      "https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: 5,
    tag: "Verified",
    price: "PKR 12.4 Cr",
    title: "Commercial Plaza",
    location: "MM Alam Road, Lahore",
    type: "Commercial",
    area: "3,200 sqft",
    image:
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1400&q=80",
  },
  {
    id: 6,
    tag: "New",
    price: "PKR 4.1 Cr",
    title: "Family Apartment (2 Bed)",
    location: "Johar Town, Lahore",
    type: "Apartment",
    area: "1,250 sqft",
    image:
      "https://images.unsplash.com/photo-1494526585095-c41746248156?auto=format&fit=crop&w=1400&q=80",
  },
];

function PropertyCard({ item }) {
  const { navigate } = useGeneral();

  const navigateHandler = async () => {
    navigate("/properties/detail?id=" + item?._id);

    const data = {
      url: apis().lisitingAddVisit + "?id=" + item?._id,
      method: "PUT",
    };
    await httpAction(data);
  };

  return (
    <div className="fpCard">
      <div className="fpCard__media">
        <img
          src={apis().localUrl + item?.data?.images[0]?.url}
          alt={item?.data?.title}
          loading="lazy"
        />
        <div className="fpCard__tag">Verified</div>

        <div className="fpCard__price">{converPrice(item?.data?.price)}</div>
      </div>

      <div className="fpCard__body">
        <h3 className="fpCard__title">{item?.data?.title}</h3>

        <div className="fpCard__loc">
          <FiMapPin />
          <span>{item?.data?.location}</span>
        </div>

        <div className="fpCard__meta">
          <div className="fpMeta">
            <FiHome />
            <span>{item?.data?.type}</span>
          </div>
          <div className="fpMeta">
            <FiMaximize2 />
            <span>{item?.data?.size}</span>
          </div>
        </div>

        <button onClick={navigateHandler} className="fpCard__btn" type="button">
          View Details <FiArrowUpRight />
        </button>
      </div>
    </div>
  );
}

export default function FeaturedProperties() {
  const [list, setList] = useState([]);
  const getListing = async () => {
    const data = {
      url: apis().getHotListing,
    };
    const result = await httpAction(data);
    if (result?.status) {
      setList(result?.list);
    }
  };

  useEffect(() => {
    getListing();
  }, []);
  const navigate = useNavigate();
  return (
    <section className="fp">
      <div className="container">
        <motion.div
          className="fp__head"
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.35 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
        >
          <div>
            <span className="fp__kicker">Handpicked</span>
            <h2 className="fp__title">Featured Properties</h2>
            <p className="fp__sub">
              Premium listings selected for location, value, and demand.
            </p>
          </div>

          <button
            onClick={() => navigate("/listing")}
            className="fp__viewAll"
            type="button"
          >
            View All <FiArrowUpRight />
          </button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.55, ease: "easeOut" }}
        >
          <Swiper
            modules={[Navigation, Pagination]}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={16}
            slidesPerView={1}
            breakpoints={{
              576: { slidesPerView: 1.2 },
              768: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 3.2 },
            }}
            className="fp__swiper"
          >
            {list?.map((item) => (
              <SwiperSlide key={item._id}>
                <PropertyCard item={item} />
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>
      </div>
    </section>
  );
}
